import { API } from "../utils";

/* تیکت‌های مشتری — درخواست‌هایی که مشتری از سازمان دارد. جدا از `tickets` که
 * پشتیبانی خود تسکامون است. */

export const getCustomerTickets = async ({ params }) =>
  API.get("/organization/customer-tickets", { params });

export const getCustomerTicket = async ({ params }) =>
  API.get(`/organization/customer-tickets/${params.uuid}`);

export const createCustomerTicket = async ({ body }) =>
  API.post("/organization/customer-tickets", body, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 120000,
  });

export const updateCustomerTicket = async ({ params, body }) =>
  API.patch(`/organization/customer-tickets/${params.uuid}`, body);

export const replyCustomerTicket = async ({ params, body }) =>
  API.post(`/organization/customer-tickets/${params.uuid}/replies`, body, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 120000,
  });

export const convertCustomerTicket = async ({ params, body }) =>
  API.post(`/organization/customer-tickets/${params.uuid}/convert`, body);

export const deleteCustomerTicket = async ({ params }) =>
  API.delete(`/organization/customer-tickets/${params.uuid}`);
